export const PRIMARY_BG_COLOUR = "#5EA29E";

export const SECONDARY_BG_COLOUR = "#9ac6b2";

export const PRIMARY_FONT_COLOUR = "#411D0A";

export const SECONDARY_FONT_COLOUR = "white";

export const TERTIARY_FONT_COLOUR = "#735240";